import {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";

export type TApiResponse = {
    status: number;
    statusText: string;
    data: any;
    error: any;
    loading: boolean;
};

export  const useApiGet = (action: string, queryParameters ?: string, showPageLoader ?: boolean): TApiResponse => {

    const dispatch = useDispatch()

    const [status, setStatus] = useState<number>(0);
    const [statusText, setStatusText] = useState<string>('');
    const [data, setData] = useState<any>();
    const [error, setError] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);

    if(queryParameters!=undefined) {
        action = action + "?" + queryParameters
    }

    const getAPIData = async () => {
        setLoading(true);
        try {

            const requestOptions = {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({action: action})
            };

            const apiResponse = await fetch('/apiloggia', requestOptions);
            const json = await apiResponse.json();
            setStatus(apiResponse.status);
            setStatusText(apiResponse.statusText);
            setData(json);
        } catch (error) {
            setError(error);
        }
        setLoading(false);
    };

    useEffect(() => {
        getAPIData();
    }, [action]);

    return { status, statusText, data, error, loading };
};
